import React from 'react';
import { IconTool, IconAlertTriangle } from '@tabler/icons-react';
export function MaintenanceSection() {
  return <section className="py-20 md:py-24 px-5 w-full bg-[#002CA5]" style={{
    background: '#002ca5'
  }} data-id="element-139">
      <div className="max-w-6xl mx-auto" data-id="element-140">
        <div className="text-center flex flex-col items-center" data-id="element-141">
          <div className="inline-block border border-[#69DCFF] rounded-full px-4 py-1 text-xs uppercase font-bold tracking-widest mb-4 text-[#69DCFF]" data-id="element-142">
            MANUTENZIONE
          </div>

          <h2 className="font-heading font-bold text-3xl md:text-4xl text-white text-center" data-id="element-143">
            E le manutenzioni?{' '}
            <span className="text-[#69DCFF]" data-id="element-144">Hai due scelte</span>.
          </h2>

          {/* Pink underline accent */}
          <div className="flex justify-center mt-4" data-id="element-145">
            <div style={{
            width: '40px',
            height: '3px',
            background: '#FF4081',
            borderRadius: '2px'
          }} data-id="element-146" />
          </div>

          <p className="text-center text-lg mt-4 max-w-2xl mx-auto font-body" style={{
          color: 'rgba(255,255,255,0.7)'
        }} data-id="element-147">
            Lo stesso algoritmo di aggregazione per zona, applicato a idraulici,
            elettricisti e serraturieri. CleanAI raggruppa le richieste vicine e
            attiva il professionista giusto al momento giusto.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mt-12" data-id="element-148">
          {/* Card 1 — Ordinari */}
          <div className="rounded-none p-7 border-2 border-accent-teal bg-white" data-id="element-149">
            <div className="mb-4" data-id="element-150">
              <IconTool size={32} stroke={1.5} style={{
              color: '#002ca5'
            }} data-id="element-151" />
            </div>

            <h3 className="font-heading font-semibold text-lg md:text-xl text-navy mb-3" data-id="element-152">
              Interventi ordinari
            </h3>

            <p className="font-body text-sm md:text-base leading-relaxed text-body-gray" data-id="element-153">
              Idraulico, elettricista, serraturiere. CleanAI raggruppa le
              richieste nella tua zona e ti manda il professionista giusto, a
              costi ridotti.
            </p>

            <div className="mt-5 rounded-none p-4 text-sm flex items-center gap-3 font-body font-medium text-[#002CA5] bg-[#F5F7FA]" data-id="element-154">
              <span className="inline-block w-2 h-2 rounded-full flex-shrink-0 bg-[#002CA5]" data-id="element-155" />
              Stessa zona, stesso tecnico, costi divisi tra host.
            </div>
          </div>

          {/* Card 2 — Urgenti */}
          <div className="relative rounded-none p-7 border-2 bg-white" style={{
          borderColor: '#FF4081'
        }} data-id="element-156">
            <div className="mb-4" data-id="element-157">
              <IconAlertTriangle size={32} stroke={1.5} style={{
              color: '#FF4081'
            }} data-id="element-158" />
            </div>

            <h3 className="font-heading font-semibold text-lg md:text-xl text-navy mb-3" data-id="element-159">
              Interventi urgenti
            </h3>

            <p className="font-body text-sm md:text-base leading-relaxed text-body-gray" data-id="element-160">
              Check-in tra poche ore e qualcosa si è rotto? CleanAI trova chi è
              già operativo nella tua zona e lo attiva subito.
            </p>

            <div className="mt-5 rounded-none p-4 text-sm flex items-center gap-3 font-body font-medium bg-[#F5F7FA] text-[#FF4081]" data-id="element-161">
              Guasto o assenza inattesa? C'è sempre qualcuno pronto vicino a te.
            </div>
          </div>
        </div>
      </div>
    </section>;
}